import { IndicatorListItem } from '../../../model/indicator-list-item';
import { IndicatorImageSource } from '../../../model/indicator-image-source';

export function createEmptyIndicator(): IndicatorListItem {
  //Note: some "empty" properties need to contain something, else the backend will not allow it
  return {
    title: 'empty',
    id: 'empty',
    _etag: 'empty',
    _ts: 0, //not used
    indicatorProperties: {
      diff: 0,
      unknownDiff: true,
      hideGraph: false,
      imgSource: IndicatorImageSource.URL,
      imgURL: '',
    },
  };
}
